const BASE_SPACING = 2;

export const getSpacing = (space: number) => {
    return space * BASE_SPACING;
};

export const spacingFromPx = (px: number) => {
    return px / BASE_SPACING;
};
